/* eslint-disable no-restricted-syntax */
import store from '@/store'
import novtiFormioComponentsCss from '!!raw-loader!@growingminds/novti-formio-components/dist/formio-contrib.css'

export default function canvas() {
  let canvasCss = null
  const scripts = []
  const styles = [
    'https://cdn.form.io/formiojs/formio.full.min.css',
  ]

  // Add the CSS to the canvas
  canvasCss += novtiFormioComponentsCss

  // Get the active Theme
  const activeTheme = store.getters['themes/getActiveTheme']
  const activeThemeStyles = store.getters['themes/getActiveExternalResources']('css')
  const activeThemeScripts = store.getters['themes/getActiveExternalResources']('js')

  if (activeTheme) {
    for (const script of activeThemeScripts) {
      scripts.push(script.src)
    }

    for (const style of activeThemeStyles) {
      styles.push(style.src)
    }

    styles.push(`${process.env.VUE_APP_CDN_URL}/${activeTheme.data.storage}/public/styles.bundle.css`)
    scripts.push(`${process.env.VUE_APP_CDN_URL}/${activeTheme.data.storage}/public/app.bundle.js`)
  }

  return {
    canvas: {
      styles,
      scripts,
    },
    canvasCss,
  }
}
